export default __webpack_public_path__ + "static/media/icon-ticket.de0a2463.svg";